import Vue from 'vue'
import Vuex from 'vuex'
import {
  getClipInfo,
  getBroadcasterChoice
} from '@/api'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: true,
    channelId: null,
    userId: null,
    opaqueId: null,
    role: null,
    isLinked: false,
    token: null,
    bitsEnabled: false,
    topClip: null,
    isVideo: false,
    broadcasterChoice: null
  },
  getters: {
    loading (state) {
      return state.loading
    },
    token (state) {
      return state.token
    },
    topClip (state) {
      return state.topClip
    },
    broadcasterChoice (state) {
      return state.broadcasterChoice
    },
    isVideo (state) {
      return state.isVideo
    }
  },
  mutations: {
    loading (state, value) {
      state.loading = value
    },
    channelId (state, value) {
      state.channelId = value
    },
    userId (state, value) {
      state.userId = value
    },
    opaqueId (state, value) {
      state.opaqueId = value
    },
    role (state, value) {
      state.role = value
    },
    isLinked (state, value) {
      state.isLinked = value
    },
    token (state, value) {
      state.token = value
    },
    bitsEnabled (state, value) {
      state.bitsEnabled = value
    },
    topClip (state, value) {
      state.topClip = value
    },
    isVideo (state, value) {
      state.isVideo = value
    },
    broadcasterChoice (state, value) {
      state.broadcasterChoice = value
    }
  },
  actions: {
    loadSettings (context) {
      const params = new URLSearchParams(window.location.search)
      const anchor = params.get('anchor')
      if (anchor === 'component') {
        context.commit('isVideo', true)
      }
    },
    onAuthorized (context, auth) {
      context.commit('channelId', auth.channelId)
      context.commit('userId', window.Twitch.ext.viewer.id)
      context.commit('opaqueId', window.Twitch.ext.viewer.opaqueId)
      context.commit('role', window.Twitch.ext.viewer.role)
      context.commit('isLinked', window.Twitch.ext.viewer.isLinked)
      context.commit('token', window.Twitch.ext.viewer.sessionToken)
      context.commit('bitsEnabled', window.Twitch.ext.features.isBitsEnabled)

      context.dispatch('getClipInformation')
        .then(_ => context.dispatch('getBroadcasterChoice'))
        .then(_ => {
          context.commit('loading', false)
        })
    },
    getClipInformation (context) {
      return getClipInfo()
        .then(topClip => {
          context.commit('topClip', topClip)
        })
    },
    getBroadcasterChoice (context) {
      return getBroadcasterChoice()
        .then(topClip => {
          context.commit('broadcasterChoice', topClip)
        })
    }
  }
})
